import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------fath-order-history-listing--------------------------
export const getNotificationApi = async (data) => {
  const endPoint =
    `/notification/notification_list` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// // ---------------------add-notification-status---------------------------
export const addNotificationApi = async (data) => {
  const endPoint = `/notification/send_notification`;
  return await axios.post(endPoint, data, setJwtToken());
};
// // ---------------------user-type-list---------------------------
export const fathUserApi = async (search) => {
  const endPoint = `/notification/user_list?search=${search}`;
  return await axios.get(endPoint, setJwtToken());
};
// ---------------------delete-notification---------------------------
export const deleteNotificationApi = async (id) => {
  const endPoint = `/notification/cancel_scheduled_notification/${id}`;
  return await axios.get(endPoint, setJwtToken());
};

export const deleteNotificationApis = async (id) => {
  const endPoint = `/notification/notification_remove/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};
